module.exports = __webpack_public_path__ + "29e1d4874f80444401a43f5b495d78ca.svg";